export enum UploadStep {
  Waiting = 1,
  Uploading,
  Ready,
}
